import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { ERROR, openNotification } from "../../utils";
//------------- TYPES -------------------------
const SET_CAT_FORMATOS = "[EXP_DIGITAL] SET_CAT_FORMATOS";
const SET_CAT_TIPO_DOCUMENTOS = "[EXP_DIGITAL] SET_CAT_TIPO_DOCUMENTOS";
const SET_CAT_DOCS_PENDIENTES = "[EXP_DIGITAL] SET_CAT_DOCS_PENDIENTES";
const SET_LISTA_BANDEJA = "[EXP_DIGITAL] SET_LISTA_BANDEJA";
const SET_TIPO_DOCUMENTO = "[EXP_DIGITAL] SET_TIPO_DOCUMENTO";
const SET_DOCUMENTO = "[EXP_DIGITAL] SET_DOCUMENTO";
const DEL_DOCUMENTO = "[EXP_DIGITAL] DEL_DOCUMENTO";
const DEL_TIPO_DOCUMENTO = "[EXP_DIGITAL] DEL_TIPO_DOCUMENTO";
const SET_FORMULARIO = "[EXP_DIGITAL] SET_FORMULARIO";
const SET_FORMULARIO_CLEAN = "[EXP_DIGITAL] SET_FORMULARIO_CLEAN";
const LOADING = "[EXP_DIGITAL] LOADING_FORMATOS";
const LOADING_LISTA = "[EXP_DIGITAL] LOADING_LISTA";
const RELOAD = "[EXP_DIGITAL] RELOAD";
const SET_ESTATUS_EXPEDIENTE = "[EXP_DIGITAL] SET_ESTATUS_EXPEDIENTE";
const VALIDAR_EXPEDIENTE = "[EXP_DIGITAL] VALIDAR_EXPEDIENTE";
//---------Modal Detalle -------------------------
const MODAL_VISIBLE_DETALLE = "[EXP_DIGITAL] MODAL_VISIBLE_DETALLE";

const CLEAN_STATE = "[EXP_DIGITAL] CLEAN_STATE";

//------------- STATE -------------------------
const initialState = {
  loading: false,
  loadingLista: false,
  reload: false,
  catalogoFormatos: [],
  catalogoExpediente: [],
  tipoDocumentos: [],
  tipoDocumentosCopia: [],
  catDocsPendientes: [],
  listaArchivosPorSubir: [],
  listaBandeja: [],
  formulario: {
    isSaved: false,
    isError: false,
    mensaje: null,
  },
  validarExpediente: {},
  //---------------------- MODALES ------------------------------------
  modalDetalle: {
    visible: false,
    documento: null,
  },
};

//------------- REDUCER -------------------------
const expDigitalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAT_FORMATOS:
      return {
        ...state,
        catalogoFormatos: [...action.payload],
      };
    case SET_CAT_TIPO_DOCUMENTOS:
      return {
        ...state,
        tipoDocumentos: [...action.payload],
        tipoDocumentosCopia: [...action.payload],
      };
    case SET_CAT_DOCS_PENDIENTES:
      return {
        ...state,
        catDocsPendientes: [...action.payload],
      };
    case RELOAD:
      return {
        ...state,
        reload: !state.reload,
      };

    case SET_LISTA_BANDEJA:
      return {
        ...state,
        listaBandeja: [...action.payload],
      };

    case SET_TIPO_DOCUMENTO:
      return {
        ...state,
        tipoDocumentos: [...state.tipoDocumentos, action.payload].sort(
          (a, b) => a.idDocumento - b.idDocumento
        ),
      };

    case SET_DOCUMENTO:
      return {
        ...state,
        listaArchivosPorSubir: [...state.listaArchivosPorSubir, action.payload],
      };

    case DEL_DOCUMENTO:
      return {
        ...state,
        listaArchivosPorSubir: state.listaArchivosPorSubir.filter(
          ({ idTipoDocumento }) => idTipoDocumento !== action.payload
        ),
      };
    case DEL_TIPO_DOCUMENTO:
      return {
        ...state,
        tipoDocumentos: state.tipoDocumentos.filter(
          ({ idDocumento }) => idDocumento !== action.payload
        ),
      };

    case SET_ESTATUS_EXPEDIENTE:
      return {
        ...state,
        catalogoExpediente: [...action.payload],
      };
    case SET_FORMULARIO:
      return {
        ...state,
        formulario: {
          isSaved: action.payload.isSaved,
          isError: action.payload.isError,
          mensaje: action.payload.message,
        },
      };
    case SET_FORMULARIO_CLEAN:
      return {
        ...state,
        formulario: {
          isSaved: false,
          isError: false,
          mensaje: null,
        },
      };

    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case VALIDAR_EXPEDIENTE:
      return {
        ...state,
        validarExpediente: { ...action.payload },
      };
    case LOADING_LISTA:
      return {
        ...state,
        loadingLista: action.payload,
      };
    case MODAL_VISIBLE_DETALLE:
      return {
        ...state,
        modalDetalle: {
          ...state.modalDetalle,
          visible: action.payload.visible,
          documento: action.payload.documento,
        },
      };
    case CLEAN_STATE:
      return initialState;
    default:
      return state;
  }
};

//------------- ACTIONS -------------------------
/**
 * Acción que guarda el tipo documento que será subido por el aspirante
 */
export const setDocumento = (state) => ({
  type: SET_DOCUMENTO,
  payload: state,
});

/**
 * Función que elimina de la lista temporal el archivo subido por el aspirante
 */
export const eliminarDocumento = (state) => ({
  type: DEL_DOCUMENTO,
  payload: state,
});

/**
 * Función que elimina de la lista de Tipo de documento seleccionado por el aspirante
 */
export const eliminarTipoDocumento = (state) => ({
  type: DEL_TIPO_DOCUMENTO,
  payload: state,
});

// ----------------------- Catalogos ---------------------------------
/**
 * Función que almacena la lista de los formatos a descargar
 */
export const setCatFormatos = (state) => ({
  type: SET_CAT_FORMATOS,
  payload: state,
});

/**
 * Función que almacena la lista de los tipos de documentos
 */
export const setTipoDocumentos = (state) => ({
  type: SET_CAT_TIPO_DOCUMENTOS,
  payload: state,
});
/**
 * Función que almacena la lista de los tipos de documentos
 */
export const setDocsPendientes = (state) => ({
  type: SET_CAT_DOCS_PENDIENTES,
  payload: state,
});

// -----------------------Fin Catalogos ---------------------------------

/**
 * Action para almacenar la respuesta del formulario.
 * @param {boolean} isError: Si hubo un error al momento de registrar/actualizar un aspirante
 * @param {boolean} isSaved: Si se registro/actualizó correctamente un aspirante
 * @param {string} message : Mensaje recibido
 */
export const setFormulario = (isError, isSaved, message) => ({
  type: SET_FORMULARIO,
  payload: {
    isError,
    message,
    isSaved,
  },
});

/**
 * Función que limpia el state de los mensajes recibidos del back
 */
export const setFormularioClean = () => ({
  type: SET_FORMULARIO_CLEAN,
});
/**
 * Función que vuelve agregar el tipo de documento a la lista
 */
export const setTipoDocumento = (state) => ({
  type: SET_TIPO_DOCUMENTO,
  payload: state,
});

export const setListaBandeja = (state) => ({
  type: SET_LISTA_BANDEJA,
  payload: state,
});
export const setValidarExpediente = (state) => ({
  type: VALIDAR_EXPEDIENTE,
  payload: state,
});
/**
 * Función que cambia el estatus del loading
 */
export const setLoading = (status) => ({
  type: LOADING,
  payload: status,
});
export const setLoadingLista = (status) => ({
  type: LOADING_LISTA,
  payload: status,
});

export const setEstatusExpediente = (state) => ({
  type: SET_ESTATUS_EXPEDIENTE,
  payload: state,
});

//--------------------------- MODAL -----------------------------------------------
export const setModalActiveDetalle = (visible, documento) => ({
  type: MODAL_VISIBLE_DETALLE,
  payload: { visible, documento },
});
/**
 * Función que limpia todo el state
 */
export const cleanExpDigital = () => ({
  type: CLEAN_STATE,
});
export const setReload = () => ({
  type: RELOAD,
});

/**
 * Función que trae el catalogo de los tipos de documentos
 * @param {number} idTipo
 * @returns []
 */
export const getCatDocumentos =
  (idTipo, idConcurso, idConvocatoria) => async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const { accessToken, idAspirante } = getState().usuarioLogin;
      const urls = await axios(window.location.origin + JSON_URL);
      const { data } = await axios.post(
        `${urls.data.urlServer}${urls.data.urlCatDocumentos}`,
        { idTipo, idAspirante, idConcurso, idConvocatoria },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      switch (idTipo) {
        case 1:
          dispatch(setTipoDocumentos(data));
          break;
        case 2:
          dispatch(setCatFormatos(data));
          break;
        default:
          dispatch(setDocsPendientes(data));
          break;
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.error(error);
    }
  };

export const getBandejaDocumentos =
  (idConcurso, idConvocatoria) => async (dispatch, getState) => {
    dispatch(setLoadingLista(true));
    const { accessToken, idAspirante } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(
        `${data.urlServer}${data.urlListaExpDigital}`,
        { idAspirante, idConcurso, idConvocatoria },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((resp) => {
        const { data } = resp;
        dispatch(setListaBandeja(data));
      })
      .catch((error) => {
        console.log(error);
      });
    dispatch(setLoadingLista(false));
  };

export const validarExpediente =
  (idConcurso, idConvocatoria) => async (dispatch, getState) => {
    // dispatch(setLoadingLista(true));
    const { accessToken } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(
        `${data.urlServer}${data.urlValidarExpediente}`,
        { idConcurso, idConvocatoria },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((resp) => {
        const { data } = resp;
        dispatch(setValidarExpediente(data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(setValidarExpediente(undefined));
      });
    // dispatch(setLoadingLista(false));
  };

export const saveExpediente = (formData) => async (dispatch, getState) => {
  dispatch(setLoading(true));

  const { accessToken } = getState().usuarioLogin;
  const { data } = await axios(window.location.origin + JSON_URL);

  await axios
    .post(`${data.urlServer}${data.urlGuardarExpediente}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
        dispatch(setReload());
      } else {
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      dispatch(setFormulario(true, false, data.mensaje));
    });
  dispatch(setLoading(false));
};

export const eliminarExpediente = (form) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const { accessToken } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(`${data.urlServer}${data.urlEliminarExpediente}`, form, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((resp) => {
        const { data } = resp;
        if (data.idMensaje === 1) {
          dispatch(setReload());
          openNotification("success", "Éxito", data.mensaje);
        }
      })
      .catch((error) => {
        const { data } = error.response;
        openNotification("error", ERROR, data.mensaje);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  } catch (error) {
    console.error(error);
  }
};

/** ----------------------------------------------------------------------------------------------------
   * 
   
   */
export const getEstatusExpediente = () => async (dispatch, getState) => {
  try {
    const { accessToken } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);
    await axios
      .post(
        `${data.urlServer}${data.urlCatExpediente}`,
        {},
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((resp) => {
        const { data } = resp;
        let catalogo = data.filter(({ idEstatus }) => idEstatus !== 1);
        dispatch(setEstatusExpediente(catalogo));
      })
      .catch((error) => {
        console.error(error?.response?.data);
      });
  } catch (error) {
    console.error(error?.response?.data);
  }
};

export default expDigitalReducer;
